module.exports = "\r\n.martop20{\r\n    margin-top: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/personnel-details/Personnels/personnel/personnel.component.css
// module id = ./src/app/pages/functions/personnel-details/Personnels/personnel/personnel.component.css
// module chunks = main